module.exports = __webpack_public_path__ + "media/videos/term-bg-8-1a30ec67.jpg";